import { Link, useHref, useLocation } from "@remix-run/react";
import React, { useState } from "react";
import { LoaderFunctionArgs } from "../deps/remix.ts";
import { RequestContext } from "../lib/request-context.ts";
import { render } from "../route-helpers.server.ts";
import { useBindings } from "../hooks/use-bindings.ts";

export const loader = (env: LoaderFunctionArgs) => {
  return render(new RequestContext(env.request), {
    rootUrl: true,
  });
};

export function TrayMenu() {
  const { rootUrl } = useBindings<typeof loader>();
  const [active, toggleActive] = useState(false);

  function handleClick() {
    toggleActive(!active);
  }

  return (
    <div>
      <div
        className="SiteHeader__Hamburger dropdown-control"
        onClick={handleClick}
      >
        <i className="far fa-bars"></i>
      </div>
      <nav
        className={`TrayMenu dropdown dropdown-sitenav --sitenav ${active ? "--active" : ""}`}
        id="trayWrapper"
      >
        <div className="TrayMenu__Inner">
          <div className="TrayMenu__Header">
            <div
              className="TrayMenu__Close dropdown-control"
              onClick={handleClick}
            >
              <i className="fal fa-times"></i>
            </div>
          </div>
          <nav className="TrayMenu__Nav">
            <ul>
              <li>
                <Link to={`${rootUrl}/edblog`}>
                  Editors' Blog
                  <span className="slash">/</span>
                  <span className="tagline">Analysis &amp; Opinion</span>
                </Link>
              </li>
              <li>
                <Link to={`${rootUrl}/news`}>News</Link>
              </li>
              <li>
                <Link to={`${rootUrl}/live-blog`}>
                  Live Blog
                </Link>
              </li>
              <li>
                <Link to={`${rootUrl}/morning-memo`}>
                  Morning Memo
                </Link>
              </li>
              <li>
                <Link to={`${rootUrl}/cafe`}>
                  Cafe
                  <span className="slash">/</span>
                  <span className="tagline">outside voices &amp; analysis</span>
                </Link>
              </li>
              <li>
                <Link to={`${rootUrl}/muckraker`}>
                  Muckraker
                  <span className="slash">/</span>
                  <span className="tagline">scandal &amp; investigations</span>
                </Link>
              </li>
              <li>
                <Link to={`${rootUrl}/prime`}>
                  Prime
                  <span className="slash">/</span>
                  <span className="tagline">Full Site Access</span>
                </Link>
              </li>
              <li>
                <Link
                  to={`${rootUrl}/podcast-series/the-josh-marshall-podcast/`}
                >
                  Podcast
                </Link>
              </li>
              <li>
                <Link to={`/feature`}>
                  Features
                </Link>
              </li>
            </ul>
          </nav>
          <div className="TrayMenu__Buy">
            <Link
              className="TrayMenu__BuyLink"
              to={`${rootUrl}/memberships?utm_source=on_site&utm_medium=menu_button&utm_campaign=on_site_membership_links`}
            >
              <div className="left">
                <span className="large-text">Memberships</span>
              </div>
              <div className="right">
                <span className="small-text">View Options</span>
                <i className="fal fa-long-arrow-right"></i>
              </div>
            </Link>
            <Link
              className="TrayMenu__BuyLink"
              to={`/contribute?utm_source=on_site&utm_medium=menu_button&utm_campaign=on_site_contribution_links`}
            >
              <div className="left">
                <span className="large-text">Contribute</span>
              </div>
              <div className="right">
                <span className="small-text">Learn More</span>
                <i className="fal fa-long-arrow-right"></i>
              </div>
            </Link>

            <Link
              className="TrayMenu__BuyLink"
              to={`${rootUrl}/newsletters`}
            >
              <div className="left">
                <span className="large-text">Newsletters</span>
              </div>
              <div className="right">
                <span className="small-text">Subscribe</span>
                <i className="fal fa-long-arrow-right"></i>
              </div>
            </Link>
            <Link
              className="TrayMenu__BuyLink"
              to="https://store.talkingpointsmemo.com/"
            >
              <div className="left">
                <span className="large-text">Get TPM Merch</span>
                <i className="far fa-tshirt"></i>
              </div>
              <div className="right">
                <span className="small-text">Shop Now</span>
                <i className="fal fa-long-arrow-right"></i>
              </div>
            </Link>
          </div>
          <div className="TrayMenu__Social">
            <div className="TrayMenu__Follow">Follow TPM</div>
            <Link
              to="https://twitter.com/tpm"
              title="twitter"
              className="TrayMenu__SocialLink"
            >
              <i className="fab fa-twitter" aria-hidden="true"></i>
            </Link>
            <Link
              to="https://facebook.com/talkingpointsmemo"
              title="facebook"
              className="TrayMenu__SocialLink"
            >
              <i className="fab fa-facebook-f" aria-hidden="true"></i>
            </Link>
            <Link
              to="https://www.instagram.com/talkingpointsmemo/"
              title="instagram"
              className="TrayMenu__SocialLink"
            >
              <i className="fab fa-instagram" aria-hidden="true"></i>
            </Link>
          </div>
          <div className="TrayMenu__SendTips">
            <Link to="mailto:talk@talkingpointsmemo.com">
              Send Comments and Tips
            </Link>
          </div>
          <div className="TrayMenu__Etc">
            <ul>
              <li>
                <Link to={`${rootUrl}/about`}>about</Link>
              </li>
              <li>
                <Link to={`${rootUrl}/contact`}>contact</Link>
              </li>
              <li>
                <Link to={`${rootUrl}/careers`}>careers</Link>
              </li>
              <li>
                <Link to={`${rootUrl}/faq`}>FAQ</Link>
              </li>
              <li>
                <Link to={`${rootUrl}/terms-of-use`}>terms of use</Link>
              </li>
              <li>
                <Link to="http://status.talkingpointsmemo.com" target="_blank">
                  site status
                </Link>
              </li>
            </ul>
          </div>
          <div className="TrayMenu__Copyright">
            <i className="fal fa-copyright"></i> {new Date().getFullYear()}{" "}
            TPM MEDIA LLC. ALL RIGHTS RESERVED.
          </div>
        </div>
      </nav>
    </div>
  );
}

export default TrayMenu;
